/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Personas_Delete_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"? This will remove it from all projects using it." |
*
* @param {Personas_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_delete_confirm_description = /** @type {((inputs: Personas_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich löschen? Dies entfernt sie aus allen Projekten, die sie verwenden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"? This will remove it from all projects using it.`)
});